import { deleteFile, uploadFile } from "../utils/file";
import firebase, { db } from "./firebase";
import { addNews, delNews, editNews } from "./services/news";
import { addProduct, delProduct, editProduct } from "./services/product";

export default {
  state: {
    AdminID: "",
    AdminName: "",
    Authority: null,
    loginState: null,
    products: [],
    missions: [],
    missionStatement: null,
    focusProductId: "",
    focusMissionId: "",
    focusNewsId: "",
    missionChange: true,
    productChange: true,
    newsChange: true,
    news: null,
    categories: [],
  },
  mutations: {
    fetchCategories: (state, payload) => {
      state.categories = [...payload];
    },
    fetchContactRequests: (state, payload) => {
      state.requests = [...payload];
    },
    resetLoginState: (state) => {
      state.AdminID = "";
      state.loginState = null;
    },
    resetAdminState: (state) => {
      state.missions = [];
      state.products = [];
      state.focusProductId = "";
      state.focusMissionId = "";
    },
    approveLogin: (state, payload) => {
      const { account, password } = payload;
      db.collection("Accounts")
        .where("account", "==", account)
        .where("password", "==", password)
        .get()
        .then((response) => {
          if (response.empty) {
            state.loginState = false;
          } else {
            state.loginState = true;
            response.forEach((doc) => {
              state.AdminID = doc.id;
              state.Authority = doc.data().authority;
              state.AdminName = doc.data().name;

              // 登入紀錄
              // db.collection('LoginLog').add({
              // admin: state.AdminName,
              // time: new Date().getTime()
              // })
            });
          }
        });
    },
    fetchProducts: (state) => {
      state.products = []; // 重置產品資料
      db.collection("Products")
        .orderBy("cateId", "desc")
        .get()
        .then((response) => {
          const data = response.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          state.products = [...data];
        });
    },
    fetchNews: (state, payload) => {
      state.news = payload;
    },
    fetchNewsCategories: (state, payload) => {
      state.newsCategories = payload
    },
    fetchMissions: (state, payload) => {
      state.missions = [...payload];
    },
    addProduct: (state, { id, statement }) => {
      state.products.push({
        id: id,
        ...statement,
      });
    },
    editProduct: (state, { itemID, statement }) => {
      const index = state.products.map(item => item.id).indexOf(itemID);
      let newProducts = [...state.products];
      newProducts.splice(index, 1, { ...state.products[index], ...statement });
      state.products = [...newProducts];
      state.productChange = !state.productChange;

    },
    delProduct: (state, payload) => {
      const index = state.products.findIndex((doc) => doc.id === payload);
      state.products.splice(index, 1);
    },
    addNews: (state, { id, statement }) => {
      state.news = [{ id, ...statement }, ...state.news];
    },
    editNews: (state, { itemID, statement }) => {
      const index = state.news.map(item => item.id).indexOf(itemID);
      let newNews = [...state.news];
      newNews.splice(index, 1, { ...state.news[index], ...statement });
      state.news = [...newNews];
      state.newsChange = !state.newsChange;
    },
    delNews: (state, payload) => {
      const index = state.news.findIndex((doc) => doc.id === payload);
      state.news.splice(index, 1);
    },
    addMission: (state, payload) => {
      state.missions = [
        {
          ...payload,
        },
        ...state.missions,
      ];
    },
    updateMission: (state) => {
      state.missionChange = !state.missionChange;
    },
    changeFocusProductId: (state, { id }) => {
      state.focusProductId = "";
      state.focusProductId = id;
    },
    changeFocusMissionId: (state, { id }) => {
      state.focusMissionId = "";
      state.focusMissionId = id;
    },
    changeFocusNewsId: (state, { id }) => {
      state.focusNewsId = "";
      state.focusNewsId = id;
    },
    addCategory: (state, payload) => {
      state.categories = [...state.categories, { ...payload }];
    },
    editCategory: (state, payload) => {
      const { id, data } = payload;
      const index = state.categories.map((cate) => cate.id).indexOf(id);
      const newCategories = [...state.categories];
      newCategories.splice(index, 1, { ...data });
      state.categories = [...newCategories];
    },
    deleteCategory: (state, payload) => {
      const { id } = payload;
      const index = state.categories.map((cate) => cate.id).indexOf(id);
      const newCategories = [...state.categories];
      newCategories.splice(index, 1);
      state.categories = [...newCategories];
    },

    deleteMission: (state, payload) => {
      db.collection("Missions")
        .doc(payload.id)
        .delete();
    },
  },
  actions: {
    addProduct,
    editProduct,
    delProduct,
    addNews,
    delNews,
    editNews,
    
    fetchCategories: async ({ commit }) => {
      const ref = db.collection("Categories");
      const snapshot = await ref.get();
      const data = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .sort((a,b) => a.order - b.order)

      commit("fetchCategories", data);
    },
    fetchContactRequests: async ({ commit }) => {
      const ref = db.collection("Contacts");
      const snapshot = await ref.orderBy("createAt", "desc").get();
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      commit("fetchContactRequests", data);
    },
    resetLoginState: ({ commit }) => {
      commit("resetLoginState");
    },
    resetAdminState: ({ commit }) => {
      commit("resetAdminState");
    },
    approveLogin: ({ commit }, payload) => {
      commit("approveLogin", payload);
    },
    fetchProducts: ({ commit }) => {
      commit("fetchProducts");
    },
    fetchNews: async ({ commit }) => {
      const response = await db
        .collection("News")
        .orderBy("date", "desc")
        .get();
      const news = response.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      commit("fetchNews", news);
    },
    fetchNewsCategories: async ({ commit }) => {
      const response = await db.collection("NewsCategories").get()
      console.log(response)
      const data = response.docs.map(doc => ({ id: doc.id, ...doc.data() }))
      commit("fetchNewsCategories", data)
    },
    fetchMissions: async ({ commit }) => {
      const accountsRef = db.collection("Accounts");
      const accountSnapshot = await accountsRef.get();
      const accountList = accountSnapshot.docs.reduce(
        (acc, doc) => ({ ...acc, [doc.id]: doc.data().name }),
        {}
      );

      const ref = db.collection("Missions");
      const snapshot = await ref.orderBy("date", "desc").get();
      const missions = snapshot.docs.map((doc) => {
        const owner = accountList[doc.data().ownerId];
        return { id: doc.id, owner, ...doc.data() };
      });
      commit("fetchMissions", missions);
    },

    addMission: async ({ commit, rootState }, payload) => {
      const { imageSelect, Statement, ...missionInfo } = payload;
      const ref = db.collection("Missions");
      const owner = rootState.login.user.name;

      switch (payload.type) {
        case "add":
          var image = imageSelect.name;
          var { id } = await ref.add({...missionInfo, owner });
          console.log("Mission written with ID: ", id);

          let storageRef = firebase.storage().ref(`images/${missionInfo.system.toLowerCase() + "s"}/${id}/${image}`);
          let snapshot = await storageRef.put(imageSelect);
          let imagePath = await snapshot.ref.getDownloadURL();
          await ref.doc(id).update({ Statement: { ...Statement, imagePath, image } });
          if (id) commit("addMission", { id, ...missionInfo, Statement: { ...Statement, imagePath, image }, owner });
          break;
        
        case "edit":
          var image = imageSelect ? imageSelect.name : null;
          var { id } = await ref.add({...missionInfo, owner });
          console.log("Mission written with ID: ", id);
          if (image) {
            let storageRef = firebase.storage().ref(`images/${missionInfo.system.toLowerCase() + "s"}/${missionInfo.itemID}/${image}`);
            let snapshot = await storageRef.put(imageSelect);
            let imagePath = await snapshot.ref.getDownloadURL();
            await ref.doc(id).update({ Statement: { ...Statement, imagePath, image } });
            if (id) commit("addMission", { id, ...missionInfo, Statement: { ...Statement, imagePath, image }, owner });
          }
          else {
            await ref.doc(id).update({ Statement: { ...Statement } });
            if (id) commit("addMission", { id, ...missionInfo, Statement: { ...Statement }, owner });
          }
          
          break;

        case "del":
          var { id } = await ref.add({...missionInfo, Statement, owner });
          if (id) commit("addMission", { id, ...missionInfo, Statement, owner });
          break;
        default:
          break;
      }
    },
    editMission: async ({ commit }, payload) => {
      const { id, mission } = payload;
      if (mission.system === "News") {
        delete mission.product;
      }
      let Ref = db.collection("Missions").doc(id);
      await Ref.update({ ...mission });
      commit("updateMission");
    },
    signMission: async ({ commit, dispatch }, payload) => {
      const { id, mission } = payload;
      let Ref = db.collection("Missions").doc(id);
      await Ref.update(mission);
      commit("updateMission");

      if (mission.state === "approve") {
        const system = mission.system;
        await dispatch(`${mission.type}${system}`, {
          id: id,
          itemID: mission.itemID,
          statement: mission.Statement,
        });
      }
    },
    changeFocusProductId: ({ commit }, payload) => {
      commit("changeFocusProductId", payload);
    },
    changeFocusMissionId: ({ commit }, payload) => {
      commit("changeFocusMissionId", payload);
    },
    changeFocusNewsId: ({ commit }, payload) => {
      commit("changeFocusNewsId", payload);
    },
    addCategory: async ({ commit }, payload) => {
      const { image, iconImage, ...data } = payload;
      const ref = db.collection("Categories");
      const snapshot = await ref.add({ ...data, order: 10 });
      const id = snapshot.id;
      const storageRef = firebase.storage().ref("images/categories");
      const uploadTask = await storageRef
        .child(`${id}/${image.name}`)
        .put(image);
      const iconUploadTask = await storageRef
        .child(`${id}/${iconImage.name}`)
        .put(iconImage);
      const bannerPath = await uploadTask.ref.getDownloadURL();
      const iconPath = await iconUploadTask.ref.getDownloadURL();
      await ref.doc(snapshot.id).update({
        banner: image.name,
        bannerPath,
        icon: iconImage.name,
        iconPath,
      });
      commit("addCategory", {
        id: snapshot.id,
        ...data,
        banner: image.name,
        bannerPath,
        icon: iconImage.name,
        iconPath,
      });
      return true;
    },
    editCategory: async ({ commit }, payload) => {
      const { id, image, iconImage, ...data } = payload;
      const ref = db.collection("Categories").doc(id);
      await ref.update({ ...data });

      if (image) {
        if (data.banner) {
          deleteFile(`${id}/${data.banner}`);
        }
        const [newBannerPath, newBanner] = await uploadFile(image, id);
        data.bannerPath = newBannerPath;
        data.banner = newBanner;
        await ref.update({ banner: newBanner, bannerPath: newBannerPath });
      }

      if (iconImage) {
        if (data.icon) {
          deleteFile(`${id}/${data.icon}`);
        }
        const [newIconPath, newIcon] = await uploadFile(iconImage, id);
        console.log(newIconPath, newIcon);
        data.iconPath = newIconPath;
        data.icon = newIcon;
        await ref.update({ icon: newIcon, iconPath: newIconPath });
      }
      data.id = id;

      console.log(data);
      commit("editCategory", { id, data });
      return true;
    },
    deleteCategory: async ({ commit }, { id, banner, icon }) => {
      if (icon) deleteFile(`${id}/${icon}`);
      if (banner) deleteFile(`${id}/${banner}`);
      const ref = db.collection("Categories").doc(id);
      await ref.delete();
      commit("deleteCategory", { id });
      return true;
    },
    sendCantactForm: async (_, payload) => {
      const ref = db.collection("Contacts");
      const createAt = firebase.firestore.FieldValue.serverTimestamp();
      try {
        const snapshot = await ref.add({ ...payload, createAt });
        return true;
      } catch (error) {
        return false;
      }
    },

    deleteMission: ({ commit }, payload) => {
      commit("deleteMission", payload);
      console.log(payload.id);
    },
  },
  getters: {
    filterProductById: (state) => {
      if (state.products.length) {
        return state.products.filter(
          (doc) => doc.id === state.focusProductId
        )[0];
      }
    },
    filterMissionByAdmin: (state, getters, rootState) => {
      if (state.missions.length) {
        let filter = state.missions.filter(
          (doc) =>
            doc.ownerId === rootState.login.user.id &&
            ["pending", "turnback"].includes(doc.state)
        );
        return filter.length ? filter : null;
      }
      return null;
    },
    filterMissionById: (state) => {
      if (state.missions.length) {
        return state.missions.filter(
          (doc) => doc.id === state.focusMissionId
        )[0];
      }
      return;
    },
    filterNewsById: (state) => {
      if (state.news.length) {
        return state.news.filter((doc) => doc.id === state.focusNewsId)[0];
      }
    },
    pendingMissionLength: (state) => {
      if (state.missions.length) {
        let filter = state.missions.filter((doc) =>
          ["pending", "turnback"].includes(doc.state)
        );
        return filter.length ? filter.length : null;
      }
    },
    categoriesOptions: (state) => {
      if (state.categories.length) {
        return state.categories.map((cate) => ({
          value: cate.id,
          text: cate.name_CH,
        }));
      }
      return [];
    },
    newsCategoryDict: (state) => {
        if (state.newsCategories.length) {
          return state.newsCategories.reduce((acc, cate) => {
            console.log(cate)
            return {
            ...acc,
            [cate.id]: { ...cate }
          }
          }, {})
        }
        return {}
      },
  },
};
